import { SkeletonHtml } from '../../skeleton';

const theObj = { __html: SkeletonHtml };
export const SkeletonLoader = () => {
  return <div dangerouslySetInnerHTML={theObj} />;
};
